module.exports = __webpack_public_path__ + "static/media/GenericTree.75c52579.PNG";